import { render, staticRenderFns } from "./ViewPhotoPost.vue?vue&type=template&id=6a49b053"
import script from "./ViewPhotoPost.vue?vue&type=script&lang=js"
export * from "./ViewPhotoPost.vue?vue&type=script&lang=js"
import style0 from "./ViewPhotoPost.vue?vue&type=style&index=0&id=6a49b053&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports